import { Button, StandardButton } from "components/Button/Button";
import React from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { useScadaPlusTheme } from "../../../../hooks/useScadaPlusTheme";
import { usePermissions } from "hooks/usePermissions";

const EditCorrectiveActionButtonContainer = styled.div`
  & div {
    color: ${(props) =>
      props.theme.colors.buttonColors.primaryButtonTextColor.primary};
  }
  grid-column: 3/4;
  justify-self: end;
`;

type Props = {
  edit: boolean;
  correctiveAction?: string;
  onClick: () => void;
};

export const EditCorrectiveActionButton: React.FC<Props> = ({
  edit,
  correctiveAction,
  onClick,
}) => {
    const account = usePermissions();
  const { formatMessage } = useIntl();
  const canUseButton = account.permissions.some(x =>
  x.permissions.some(p =>
    p === "CONTROL" || p === "CONFIRM"
  )
);

  return (
    <React.Fragment>
      {!edit && (
        <EditCorrectiveActionButtonContainer>
          <Button
            disabled={!canUseButton}
            size="small"
            onclick={onClick} type={"primary"}          >
            {correctiveAction
              ? formatMessage({
                  id: "alarms.Edit",
                  defaultMessage: "Edit",
                })
              : formatMessage({
                  id: "alarms.AddCorrectiveAction",
                  defaultMessage: "Add corrective action",
                })}                  
          </Button>


        </EditCorrectiveActionButtonContainer>
      )}
    </React.Fragment>
  );
};
